import dayjs from "dayjs";
import { ColDef } from "ag-grid-community";
import { useQuery } from "@tanstack/react-query";
import { ChangeEvent, useState } from "react";
import { request } from "../../../common/api";
import { LoginLog } from "../../../common/types/loginLog";
import { GET_SEARCH_LOGINLOGS } from "../../../common/query-keys";
import { Grid } from "../../../components/molecules/Grid";
import { InputText } from "../../../components/atoms/Inputs/InputText";
import { InputSelect } from "../../../components/atoms/Inputs/InputSelect";
import { PageContent } from "../../../components/organisms/Contents/PageContent";
import { SearchContainer } from "../../../components/containers/SearchContainer";

const searchKeywordSelectOptions = [
  { value: "logUserId", label: "접속자ID" },
  { value: "logLoginTime", label: "로그인 시간" },
  { value: "logLogoutTime", label: "로그아웃 시간" },
  { value: "logLoginTotalTime", label: "접속누적시간" },
  { value: "logLoginIp", label: "접속IP" },
];

export const AccessLogPage = () => {
  const [search, setSearch] = useState({
    startDate: dayjs().subtract(1, "month").format("YYYY-MM-DD"),
    endDate: dayjs().format("YYYY-MM-DD"),
  });
  const [searchInputType, setSearchInputType] = useState("text");

  const { data: loginLogs } = useQuery({
    queryKey: [GET_SEARCH_LOGINLOGS, search],
    queryFn: async () => {
      return await request<LoginLog[]>({
        method: "GET",
        url: "/login-log/search",
        params: search,
      });
    },
  });

  const handleSearchKeywordChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const searchKeyword = e.target.value;
    if (["logLoginTime", "logLogoutTime"].includes(searchKeyword)) {
      setSearchInputType("date");
    } else {
      setSearchInputType("text");
    }
  };

  const handleSearch = (search: any) => {
    setSearch(search);
  };

  const columnDefs: ColDef[] = [
    {
      headerName: "No",
      valueGetter: "node.rowIndex + 1",
      width: 50,
    },
    {
      headerName: "접속자 ID",
      field: "logUserId",
      width: 150,
    },
    {
      headerName: "로그인 시간",
      field: "logLoginTime",
      width: 200,
      valueFormatter: (params) => {
        return dayjs(params.value).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    {
      headerName: "로그아웃 시간",
      field: "logLogoutTime",
      width: 200,
      valueFormatter: (params) => {
        return (
          params.value && dayjs(params.value).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      headerName: "접속누적시간",
      field: "logLoginTotalTime",
      width: 200,
    },
    {
      headerName: "접속 IP",
      field: "logLoginIp",
      flex: 1,
    },
  ];

  return (
    <PageContent
      depth01Title="관리자 설정"
      depth02Title="사용자 관리"
      depth03Title="접속로그 관리"
    >
      <>
        <SearchContainer
          onSearch={handleSearch}
          components={[
            <InputText
              name="startDate"
              type="date"
              size="md"
              width={115}
              defaultValue={search?.startDate}
            />,
            <>~</>,
            <InputText
              name="endDate"
              type="date"
              size="md"
              width={115}
              defaultValue={search?.endDate}
            />,
            <InputSelect
              name="searchKeyword"
              size="md"
              placeholder="구분"
              options={searchKeywordSelectOptions}
              onChange={handleSearchKeywordChange}
            />,
            <InputText
              type={searchInputType}
              name="searchValue"
              size="md"
              placeholder="Search"
            />,
          ]}
        />

        <Grid rowData={loginLogs} columnDefs={columnDefs} />
      </>
    </PageContent>
  );
};
